import { Box } from '@rbilabs/universal-components';

export const TotalsContainer = Box.withConfig({
  // account for 1rem margin on totals row
  paddingTop: '$1.5',
  paddingX: '$9',
  paddingBottom: '$5',
  marginTop: '$4',
  marginBottom: '$6',
  borderBottomWidth: '1px',
  borderBottomColor: Styles.color.black,
  _text: {
    fontFamily: Styles.fontFamily.base,
  },
});
